import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInformation = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 8,
	height: 8,
	viewBox: "0 0 8 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4 0C1.792 0 0 1.792 0 4C0 6.208 1.792 8 4 8C6.208 8 8 6.208 8 4C8 1.792 6.208 0 4 0Z",
			fill: "#3F3F3F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.0001 4.48001C3.7801 4.48001 3.6001 4.26401 3.6001 4V2.07998C3.6001 1.81598 3.7801 1.59998 4.0001 1.59998C4.2201 1.59998 4.4001 1.81598 4.4001 2.07998V4C4.4001 4.26401 4.2201 4.48001 4.0001 4.48001Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.4001 6.39995H3.6001V5.43994H4.4001V6.39995Z",
			fill: "white"
		})
	]
});
export default SvgInformation;
